import { Category, Location, Customer, Supplier, FormStatus, Product, StorageRead, TransactionRead } from "@/types";
import { NavigateFunction } from "react-router-dom";
import { logger } from "./secureLogger";

export function paramGuardStorage({ storageId, storageStatus, storage, navigate }: { storageId?: string, storageStatus: FormStatus, storage: StorageRead | null, navigate: NavigateFunction }) {
    if (!storageId || storageId === "undefined") {
        logger.warn(`paramGuardStorage: Missing or invalid storageId.`)
        navigate('/storages')
        return false
    }
    if (storageStatus === FormStatus.ERROR || (storageStatus === FormStatus.SUCCESS && !storage)) {
        logger.warn(`paramGuardStorage: Invalid storageId or storage not found.`)
        navigate('/storages')
        return false
    }
    return true
}

export function paramGuardCategory({ storageId, categoryId, categoryStatus, category, navigate }: { storageId?: string, categoryId?: string, categoryStatus: FormStatus, category: Category | null, navigate: NavigateFunction }) {
    if (!categoryId || categoryId === "undefined") {
        logger.warn(`paramGuardCategory: Missing or invalid categoryId.`)
        navigate(`/storage/categories`)
        return false
    }
    if (categoryStatus === FormStatus.ERROR || (categoryStatus === FormStatus.SUCCESS && !category)) {
        logger.warn(`paramGuardCategory: Invalid categoryId or category not found.`)
        navigate(`/storage/categories`)
        return false
    }
    return true
}

export function paramGuardLocation({ storageId, locationId, locationStatus, location, navigate }: { storageId?: string, locationId?: string, locationStatus: FormStatus, location: Location | null, navigate: NavigateFunction }) {
    if (!locationId || locationId === "undefined") {
        logger.warn(`paramGuardLocation: Missing or invalid locationId.`)
        navigate(`/storage/locations`)
        return false
    }
    if (locationStatus === FormStatus.ERROR || (locationStatus === FormStatus.SUCCESS && !location)) {
        logger.warn(`paramGuardLocation: Invalid locationId or location not found.`)
        navigate(`/storage/locations`)
        return false
    }
    return true
}

export function paramGuardProduct({ storageId, productId, product, productStatus, navigate }: { storageId?: string, productId?: string, product: Product | null, productStatus: FormStatus, navigate: NavigateFunction }) {
    if (!productId || productId === "undefined") {
        logger.warn(`paramGuardProduct: Missing or invalid productId.`)
        navigate(`/storage/products`)
        return false
    }
    if (productStatus === FormStatus.ERROR || (productStatus === FormStatus.SUCCESS && !product)) {
        logger.warn(`paramGuardProduct: Invalid productId or product not found.`)
        navigate(`/storage/products`)
        return false
    }
    return true
}

export function paramGuardCustomer({ storageId, customerId, customerStatus, customer, navigate }: { storageId?: string, customerId?: string, customerStatus: FormStatus, customer: Customer | null, navigate: NavigateFunction }) {
    if (!customerId || customerId === "undefined") {
        logger.warn(`paramGuardCustomer: Missing or invalid customerId.`)
        navigate(`/storage/customers`)
        return false
    }
    if (customerStatus === FormStatus.ERROR || (customerStatus === FormStatus.SUCCESS && !customer)) {
        logger.warn(`paramGuardCustomer: Invalid customerId or customer not found.`)
        navigate(`/storage/customers`)
        return false
    }
    return true
}

export function paramGuardSupplier({ storageId, supplierId, supplierStatus, supplier, navigate }: { storageId?: string, supplierId?: string, supplierStatus: FormStatus, supplier: Supplier | null, navigate: NavigateFunction }) {
    if (!supplierId || supplierId === "undefined") {
        logger.warn(`paramGuardSupplier: Missing or invalid supplierId.`)
        navigate(`/storage/suppliers`)
        return false
    }
    if (supplierStatus === FormStatus.ERROR || (supplierStatus === FormStatus.SUCCESS && !supplier)) {
        logger.warn(`paramGuardSupplier: Invalid supplierId or supplier not found.`)
        navigate(`/storage/suppliers`)
        return false
    }
    return true
}

export function paramGuardTransaction({ storageId, transactionId, transactionStatus, transaction, navigate }: { storageId?: string, transactionId?: string, transactionStatus: FormStatus, transaction: TransactionRead | null, navigate: NavigateFunction }) {
    if (!transactionId || transactionId === "undefined") {
        logger.warn(`paramGuardTransaction: Missing or invalid transactionId.`)
        navigate(`/storage/transactions`)
        return false
    }
    if (transactionStatus === FormStatus.ERROR || (transactionStatus === FormStatus.SUCCESS && !transaction)) {
        logger.warn(`paramGuardTransaction: Invalid transactionId or transaction not found.`)
        navigate(`/storage/transactions`)
        return false
    }
    return true
}
